import { render, staticRenderFns } from "./TabsBar.vue?vue&type=template&id=aba7b1d6&scoped=true&"
import script from "./TabsBar.vue?vue&type=script&lang=js&"
export * from "./TabsBar.vue?vue&type=script&lang=js&"
import style0 from "./TabsBar.vue?vue&type=style&index=0&id=aba7b1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba7b1d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aba7b1d6')) {
      api.createRecord('aba7b1d6', component.options)
    } else {
      api.reload('aba7b1d6', component.options)
    }
    module.hot.accept("./TabsBar.vue?vue&type=template&id=aba7b1d6&scoped=true&", function () {
      api.rerender('aba7b1d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/TabsBar.vue"
export default component.exports